import Vue from 'vue'
import Router from 'vue-router'

//手机页面
import MobileIndex from "@/components/MobileIndex";
import jyyb from "@/components/mobile/jyyb";
import wxyt from "@/components/mobile/wxyt";
import typhoon from "@/components/mobile/typhoon";
import leida from "@/components/mobile/leida";
import rainFb from "@/components/mobile/rainFb";
import rainSk from "@/components/mobile/rainSk";
import Hd from "@/components/mobile/Hdsq";
import Sk from "@/components/mobile/Sksq";

// 首页
const HomeIndex = r => require.ensure([], () => r(require('@/components/HomeIndex')), 'HomeIndex')
const login = r => require.ensure([], () => r(require('@/components/login')), 'login')
const maintenance = r => require.ensure([], () => r(require('@/components/maintenance/maintenance')), 'maintenance')
Vue.use(Router)

let router = new Router({
  // mode: "history",
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: maintenance
    },
    {
    path: '/index',
    name: 'HomeIndex',
    component: HomeIndex
    },
      {
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex
    },
    {
      path: '',
      name: 'HomeIndex',
      component: HomeIndex,
        },
    {
      path: '/mobile',
      name: 'MobileIndex',
      component: MobileIndex
    },
    {
      path: '/jyyb',
      name: 'jyyb',
      component: jyyb
    },
    {
      path: '/wxyt',
      name: 'wxyt',
      component: wxyt
    },{
      path: '/leida',
      name: 'leida',
      component: leida
    },{
      path: '/typhoon',
      name: 'typhoon',
      component: typhoon
    },{
      path: '/rainFb',
      name: 'rainFb',
      component: rainFb
    },{
      path: '/rainSk',
      name: 'rainSk',
      component: rainSk
    },{
      path: '/Hd',
      name: 'Hd',
      component: Hd
    },{
      path: '/Sk',
      name: 'Sk',
      component: Sk
    }
  ]
})
router.beforeEach((to, from, next) => {
  // console.log(to, from, next)
  let user = sessionStorage.getItem("userId");
  if (!user && to.path != "/login") {
    if(to.path=="/maintenance"){
      next({ path: "/login" });
    }else{
      next();
    }
  }else{
    next();
  }
  //判断是否为移动设备，是，则跳转到移动端的路由
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    if(to.path == "/"){
      next({ path: "/mobile" });
    }
  }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js